import { render, staticRenderFns } from "./Laboratories.vue?vue&type=template&id=43518076&"
import script from "./Laboratories.vue?vue&type=script&lang=js&"
export * from "./Laboratories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports